import React from 'react';
import style from './smalltitle.module.css';

const SmallTitle = ({ children, customClass}) => {
    return (
      <h3 className={customClass}>{children}</h3>
    );
};

export default SmallTitle;